import { usePlanShortStayParams as useShortStayParams } from "@/components/features/items/edit/plan/_shared/ui/components/stay-length/short-stay-params/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanShortStayParams = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { shortStayParams } = viewModel;

	return useShortStayParams({ onSetViewModel, shortStayParams });
};
